"use client";

import { motion } from "framer-motion";

const brands = [
  { name: "Shopify",      src: "/Shopify.svg"         },
  { name: "Yampi",        src: "/Yampi.webp"          },
  { name: "WhatsApp",     src: "/WhatsApp_nobg.png"   },
  { name: "Instagram",    src: "/Instagram.png"       },
  { name: "AppMax",       src: "/AppMax.webp"         },
  { name: "Correios",     src: "/Correios.png"        },
  { name: "17Track",      src: "/17track.svg"         },
  { name: "Melhor Envio", src: "/MelhorEnvio.png"     },
  { name: "Sihi",         src: "/Sihi_nobg.png"       },
  { name: "Gmail",        src: "/Gmail_nobg.png"      },
  { name: "Messenger",    src: "/Messenger.png"       },
];

export function SocialProofLP3() {
  return (
    <section className="py-12 border-y border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-white/[0.02] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center text-xs font-bold uppercase tracking-widest text-gray-400 dark:text-gray-500 mb-12"
        >
          Conecta com as plataformas que você já usa
        </motion.p>
      </div>

      {/* Marquee — single track, -50% loop, zero gap between end and start */}
      <div className="relative w-full overflow-hidden">
        {/* Edge fades */}
        <div className="absolute left-0 top-0 bottom-0 w-20 z-10 pointer-events-none bg-gradient-to-r from-gray-50 dark:from-[#0a0a0f] to-transparent" />
        <div className="absolute right-0 top-0 bottom-0 w-20 z-10 pointer-events-none bg-gradient-to-l from-gray-50 dark:from-[#0a0a0f] to-transparent" />

        {/* Single flex row — items + exact duplicate in one container → animate -50% */}
        <div className="flex items-center animate-marquee my-6">
          {[...brands, ...brands].map((b, i) => (
            <div
              key={i}
              className="flex-shrink-0 mx-5 flex items-center justify-center hover:scale-110 transition-transform duration-500 ease-in-out cursor-pointer"
              style={{ width: "8rem", height: "2.75rem" }}
              aria-hidden={i >= brands.length}
            >
              <img
                src={b.src}
                alt={i < brands.length ? b.name : ""}
                className="w-full h-full object-contain grayscale opacity-40 dark:invert hover:grayscale-0 hover:opacity-100 dark:hover:invert-0 [transition:filter_500ms_ease-in-out,opacity_500ms_ease-in-out]"
                draggable={false}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Stats */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-8">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-12 sm:gap-20 text-center"
        >
          {[
            { value: "+500", label: "e-commerces ativos" },
            { value: "R$12M+", label: "em pedidos gerenciados" },
            { value: "98%", label: "de satisfação (CSAT)" },
          ].map(({ value, label }) => (
            <div key={label} className="flex flex-col gap-1">
              <span className="text-5xl font-black tracking-tight bg-gradient-to-r from-primary via-purple-600 to-pink-600 bg-clip-text text-transparent">
                {value}
              </span>
              <span className="text-sm font-semibold text-gray-400 dark:text-gray-500">{label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
